import { render, staticRenderFns } from "./WsAuthLayout.vue?vue&type=template&id=171276e9&"
import script from "./WsAuthLayout.vue?vue&type=script&lang=js&"
export * from "./WsAuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./WsAuthLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports